// Site navigation structure (EP-001 v1.1: D21, D22, D28).
//
// The primary navigation is editable in Sanity through the Navigation document's
// "Menu (EP-001)" field (`menuItems`), where an item may hold sub-links. Until that field
// has content, the approved structure below is used. The older `primaryItems` field is
// left untouched so the current live site keeps working until the redesign ships.

export const SERVICE_PILLARS = [
    { _key: "managed-it", label: "Managed IT", url: "/services/managed-it-operational-excellence" },
    { _key: "cybersecurity", label: "Cybersecurity", url: "/services/cybersecurity-risk-protection" },
    { _key: "cloud", label: "Cloud & Infrastructure", url: "/services/cloud-infrastructure-scalability" },
    { _key: "leadership", label: "Technology Leadership", url: "/services/it-strategy-advisory-vcio" },
];

export const DEFAULT_MENU = [
    { _key: "enterprise", label: "Enterprise", url: "/enterprise" },
    { _key: "healthcare", label: "Healthcare Secure™", url: "/healthcare-secure" },
    {
        _key: "services",
        label: "Services",
        url: "/services",
        children: [...SERVICE_PILLARS, { _key: "all-services", label: "All services", url: "/services" }],
    },
    { _key: "perspective", label: "Perspective", url: "/perspective" },
    {
        _key: "about",
        label: "About",
        url: "/about",
        children: [
            { _key: "about-easilinked", label: "About EasiLinked", url: "/about" },
            { _key: "contact", label: "Contact", url: "/contact" },
        ],
    },
];

const isLink = (l) => l && typeof l.label === "string" && l.label.trim() && typeof l.url === "string" && l.url.trim();

// Keeps only well-formed items from Sanity; falls back to the approved menu.
export const normalizeMenu = (items) => {
    if (!Array.isArray(items)) return DEFAULT_MENU;
    const clean = items.filter(isLink).map((item) => ({
        ...item,
        children: Array.isArray(item.children) ? item.children.filter(isLink) : undefined,
    }));
    return clean.length ? clean : DEFAULT_MENU;
};

export const isExternal = (url) => /^https?:\/\//i.test(url || "");

// Links shown under the "Services" footer column: the Services sub-links, minus "All services".
export const footerServiceLinks = (menu) => {
    const services = menu.find((i) => i.url === "/services" && i.children?.length);
    const links = (services?.children || SERVICE_PILLARS).filter((l) => l.url !== "/services");
    return links.length ? links : SERVICE_PILLARS;
};
